<template>
  <!-- /ダイアログ -->
  <v-dialog
    :value="enableDialog"
    persistent
    width="600"
  >
    <v-form>
      <validation-observer
        ref="subscriberFormValidation"
      >
        <v-card flat>
          <v-toolbar flat>
            <v-toolbar-title>加入者番号、公開確認番号</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text
            style="max-height: 50vh;overflow-y: scroll;"
          >
            <template
              v-for="number in forms.numbers"
            >
              <v-card
                :key="number.key"
                class="mt-2"
                outlined
              >
                <v-card-text
                  class="pb-0"
                >
                  <v-row>
                    <v-col cols="12" md="6">
                      <validation-provider
                        v-slot="{ errors }"
                        class="requiredMark"
                        name="加入者番号"
                        :rules="{required: true, alpha_num_only: true, length: 7, subscriberNumberInitialsCheck: {mode: dialogType}}"
                      >
                        <v-text-field
                          v-model="number.subscriber_number"
                          :error-messages="errors"
                          dense
                          label="加入者番号"
                          hide-details="auto"
                          outlined
                          persistent-placeholder
                          :placeholder="`例）${ transports.includes(dialogType) ? '2222222' : '3333333' }`"
                        >
                          <template v-slot:label>
                            <span>加入者番号</span>
                            <span class="ml-1">
                              ({{ number.subscriber_number?.length || 0 }} / 7)
                            </span>
                          </template>
                          <template v-slot:counter></template>
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="6">
                      <validation-provider
                        v-slot="{ errors }"
                        class="requiredMark"
                        name="公開確認番号"
                        rules="required|numeric|length: 6"
                      >
                        <v-text-field
                          v-model="number.confirmation_number"
                          :error-messages="errors"
                          dense
                          label="公開確認番号"
                          hide-details="auto"
                          outlined
                          persistent-placeholder
                          placeholder="例）111111"
                        >
                          <template v-slot:label>
                            <span>公開確認番号</span>
                            <span class="ml-1">
                              ({{ number.confirmation_number?.length || 0 }} / 6)
                            </span>
                          </template>
                          <template v-slot:counter></template>
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    :disabled="forms.numbers.length <= 1"
                    color="error"
                    small
                    @click="removeButtonClickEvent(number)"
                  >
                    <v-icon small>
                      mdi-trash-can-outline
                    </v-icon>削除
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              small
              color="info"
              @click="addNumbersButtonClickEvent"
            >
              行を追加&nbsp;<v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-actions>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn @click="closeButtonClickEvent">
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              登録
            </v-btn>
          </v-card-actions>
        </v-card>
      </validation-observer>
    </v-form>
  </v-dialog>
  <!-- ダイアログ -->
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'SubscriberEditDialog',
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    dialogType: {
      type: String,
      default: () => "transport",
    }
  },
  data() {
    return {
      forms: {
        numbers: []
      },
      transports: ['transport', 'admin_transport']
    }
  },
  computed: {},
  watch: {
    enableDialog (newVal) {
      if (newVal) {
        Object.assign(this.$data.forms, this.$options.data().forms);
        this.addNumbersButtonClickEvent()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverMasterTransport', {
      createDriverTransport: 'create',
    }),
    ...mapActions('DriverMasterDisposer', {
      createDriverDisposer: 'create',
    }),
    ...mapActions('AdminMasterTransport', {
      createAdminTransport: 'create',
    }),
    ...mapActions('AdminMasterDisposer', {
      createAdminDisposer: 'create',
    }),
    /**
     * 行追加ボタン クリックイベント
     */
    addNumbersButtonClickEvent () {
      let random = parseInt(new Date().getTime())
      this.forms.numbers.push({ key: random, subscriber_number: null, confirmation_number: null })
    },
    /**
     * 削除ボタン クリックイベント
     * @param item
     */
    removeButtonClickEvent (item) {
      this.forms.numbers = this.forms.numbers.filter( o => o.key !== item.key)
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
     * 登録するボタン クリックイベント
     */
    registerButtonClickEvent () {
      let $self = this
      this.$refs.subscriberFormValidation.validate().then((result) => {
        if(result){
          this.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation(){
      if (this.dialogType === 'transport') {
        this.createDriverTransport({ params: this.forms }).then(() => {
          this.$emit('registerEvent', this.forms)
        })
      } else if (this.dialogType === 'disposer') {
        this.createDriverDisposer({ params: this.forms }).then(() => {
          this.$emit('registerEvent', this.forms)
        })
      } else if (this.dialogType === 'admin_transport') {
        this.createAdminTransport({ params: this.forms }).then(() => {
          this.$emit('registerEvent', this.forms)
        })
      } else {
        this.createAdminDisposer({ params: this.forms }).then(() => {
          this.$emit('registerEvent', this.forms)
        })
      }
    },
  }
}
</script>

<style scoped>

</style>
